import { render, staticRenderFns } from "./CadastroOfertaGrades.vue?vue&type=template&id=2e1fea06"
import script from "./CadastroOfertaGrades.vue?vue&type=script&lang=js"
export * from "./CadastroOfertaGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports